import {
  GET_OFFERS_FAILED,
  GET_OFFERS_START,
  GET_OFFERS_SUCCESS,
  GET_OFFER_BY_ID_FAILED,
  GET_OFFER_BY_ID_START,
  GET_OFFER_BY_ID_SUCCESS,
  GET_PAGINATED_OFFERS_START,
  GET_PAGINATED_OFFERS_SUCCESS,
  GET_PAGINATED_OFFERS_FAILED,
} from "../actions/actionTypes";

const initialState = {
  offer: {
    offer: {},
    success: false,
    isLoading: true,
    error: "",
    page: 1,
  },
  offers: {
    offers: {},
    success: false,
    isLoading: true,
    error: "",
    page: 1,
  },
};
const offers = (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFERS_START:
      return {
        ...initialState,
        isLoading: true,
      };

    case GET_OFFERS_SUCCESS:
      return {
        ...initialState,
        offers: action.payload,
        isLoading: false,
        success: true,
      };

    case GET_OFFERS_FAILED:
      return {
        ...initialState,
        error: action.payload,
        isLoading: false,
      };

    case GET_OFFER_BY_ID_START:
      return {
        ...initialState,
        isLoading: true,
      };

    case GET_OFFER_BY_ID_SUCCESS:
      return {
        ...initialState,
        offer: action.payload,
        isLoading: false,
        success: true,
      };

    case GET_OFFER_BY_ID_FAILED:
      return {
        ...initialState,
        error: action.payload,
        isLoading: false,
      };

    case GET_PAGINATED_OFFERS_START:
      return {
        ...initialState,
        isLoading: true,
      };

    case GET_PAGINATED_OFFERS_SUCCESS:
      return {
        ...initialState,
        offers: action.payload,
        isLoading: false,
        success: true,
      };

    case GET_PAGINATED_OFFERS_FAILED:
      return {
        ...initialState,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default offers;
